import React, { useState } from 'react';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { getPolyglot, withPolyglot } from '../../../../../i18n';
import AddStoreModal from '../../StoreManager/AddStoreModal/AddStoreModal';
import { StoreIcon } from '../../../theme/icons';

function EmptyStateStoreCard() {
  const polyglot = getPolyglot();
  const [showAddStore, setShowAddStore] = useState(false);

  const onAddStore = () => {
    setShowAddStore(true);
  };

  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
        padding={4}
      >
        <Card
          elevation={2}
          sx={{
            maxWidth: 600,
            width: '100%',
            textAlign: 'center',
            padding: 3,
          }}
        >
          <CardContent>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: 3,
                color: 'primary.main',
              }}
            >
              <StoreIcon
                style={{
                  height: '5rem',
                }}
              />
            </Box>
            <Typography variant="h5" component="h2" gutterBottom>
              {polyglot.t('group.empty_state.welcome_title')}
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              paragraph
              sx={{ marginBottom: 3 }}
            >
              {polyglot.t('group.empty_state.welcome_message')}
            </Typography>
            <Button
              variant="contained"
              size="large"
              onClick={onAddStore}
              startIcon={<StoreIcon />}
            >
              {polyglot.t('group.empty_state.add_store_button')}
            </Button>
          </CardContent>
        </Card>
      </Box>
      <AddStoreModal
        showModal={showAddStore}
        closeModal={() => setShowAddStore(false)}
      />
    </>
  );
}

export default EmptyStateStoreCard;
